"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAdd(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "6 0 12 24" }, props),
        React.createElement("path", { d: "M18 13h-5v5h-2v-5H6v-2h5.001L11 6h2l.001 5H18z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Add')(SvgAdd);
//# sourceMappingURL=Add.js.map